/**
 * Add the datasource base URL to a relative url
 * @param {*} _url
 * @param {*} dataSource url
 * @param { forceRAWURL } _options if input url is wrapped by "url()" it prevents rewrapping in the output
 */
const mediaFolderRegexp = /^media-[a-f\d]{24}$/i;
export function setUrlToDataSource(_url, dataSourceUrl, _options) {
	const options = Object.assign(
		{
			forceRAWURL: false,
			checkForMediaFolder: false,
		},
		_options
	);
	let url = _url ? _url.trim() : '';

	let hasUrl = /^url/.test(url);
	let hasKommas = false;
	if (hasUrl) {
		url = url.slice(4, url.length - 1);
		hasKommas = /^"/.test(url);
		if (hasKommas) url = url.slice(1, url.length - 1);
	}

	// prevent output url wrapping if options.forceRAWURL
	hasUrl = hasUrl && !options.forceRAWURL;
	hasKommas = hasKommas && !options.forceRAWURL;
	if (/^\.\./.test(url)) {
		return `${hasUrl ? 'url(' : ''}${hasKommas ? '"' : ''}${url.replace(
			'../',
			`${dataSourceUrl.replace(/\/*$/, '')}/apps/`
		)}${hasKommas ? '"' : ''}${hasUrl ? ')' : ''}`;
	}

	let foundApps = false;
	const parts = url.split('/');
	const result = [];

	for (const part of parts) {
		if (options.checkForMediaFolder) {
			if (mediaFolderRegexp.test(part)) {
				// used for older ios devices
				foundApps = true;
				result.push('apps');
			}
		} else {
			if (part === 'apps') {
				foundApps = true;
			}
		}
		if (foundApps) {
			result.push(part);
		}
	}

	url = dataSourceUrl + result.join('/');

	return hasUrl ? `url(${url})` : url;
}
